import { DialogContent as MuiDialogContent } from '@mui/material';
import styled from 'styled-components';

const DialogContent = styled(MuiDialogContent)<Partial<Props>>`
  padding: ${(props) => props.padding || '0 20px'};
  width: ${(props) => props.width || '100%'};
  border: none;
`;

export default DialogContent;

interface Props {
  padding: string
  width: string
  maxWidth: string
}
